import React from 'react'
import './Index.css'
import AboutUs from './AboutUs'
import QuickLink from './QuickLink'
import Services from './Services'
import Social from '../SocialNetworking/Index'

const Index = (props) => {
    return (
        <div  className="container-fluid socialComponent mt-5 pt-5" ref = {props.refer}  >
            <div style = {{
            backgroundColor : '#1F243A'}} className="row mt-5 justify-content-center text-center" >
            <div className="col-auto" >
                <AboutUs />
                <Social />
            </div>
            {/* <div className="col-auto" >
            <QuickLink onHomeClick = {props.onHomeClick} onServiceClick = {props.onServiceClick} 
                onContactClick = {props.onContactClick} onTestimonialClick = {props.onTestimonialClick} />
            </div>
            <div className="col-auto " >
            <Services />    
            </div> */}
            </div>
                
               
           
        </div>
    )
}

export default Index
